import { BiRadioCircle } from 'react-icons/bi'
import { Icon, IconProps, forwardRef } from '@chakra-ui/react'

export const OmRadioCircle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} {...props} as={BiRadioCircle} />
))
